import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientService } from '../../../core/services/client.service';

@Component({
  selector: 'app-privacy-notice-template',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy-notice-template.component.html',
})
export class PrivacyNoticeTemplateComponent {
  private clientService = inject(ClientService);
  clientId = this.clientService.clientId;
}
